export const SUBMISSION_EMAIL = "ophthalmologyq-submissions@masterq.co.uk";

export function essayPrizeMailto(subject: string) {
  return `mailto:${SUBMISSION_EMAIL}?subject=${encodeURIComponent(subject)}`;
}

export const SUBMISSION_MAILTO = essayPrizeMailto("National Essay Prize — Submission");

export const ESSAY_PRIZE_CLOSING_DATE = "1st October 2026";
export const ESSAY_PRIZE_HEAR_BACK_DATE = "1st January 2027";

export type EssayPrizeCategory = {
  slug: string;
  path: string;
  /** Short label for nav / footer sub-menu */
  navLabel: string;
  shortLabel: string;
  title: string;
  audienceLabel: string;
  eligibility: string[];
  essayQuestion: string;
  mailtoSubject: string;
};

export const ESSAY_PRIZE_CATEGORIES: EssayPrizeCategory[] = [
  {
    slug: "undergraduate-foundation",
    path: "/national-essay-prizes/undergraduate-foundation",
    navLabel: "Undergraduate & Foundation",
    shortLabel: "Medical students & final year doctors",
    title: "Undergraduate & Foundation",
    audienceLabel: "Medical students & final year doctors",
    eligibility: [
      "Open to all UK medical students (Years 1–6) and Foundation Year 1 & 2 doctors.",
      "No prior ophthalmology experience required.",
    ],
    essayQuestion:
      "Will artificial intelligence replace the ophthalmologist? Critically evaluate the current and emerging role of AI in ophthalmic diagnosis, screening, and surgical planning, and discuss the implications for medical student training and the future ophthalmic workforce.",
    mailtoSubject: "National Essay Prize — Category 1 Submission",
  },
  {
    slug: "trainees-fellows",
    path: "/national-essay-prizes/trainees-fellows",
    navLabel: "Specialty Trainees & Fellows",
    shortLabel: "Trainees & fellows",
    title: "Specialty Trainees & Fellows",
    audienceLabel: "Trainees & fellows",
    eligibility: [
      "Open to all ophthalmology specialty trainees (ST1–ST7) and post-CCT clinical or research fellows practising in the UK.",
    ],
    essayQuestion:
      "With increasing subspecialisation, reduced operative exposure, and the rapid integration of AI-assisted diagnostics, critically evaluate whether the current ophthalmology training pathway in the UK remains fit for purpose — and propose a bold reform for the next decade.",
    mailtoSubject: "National Essay Prize — Category 2 Submission",
  },
];

export const ESSAY_PRIZES_OVERVIEW_PATH = "/national-essay-prizes";

export const ESSAY_PRIZE_NAV_ITEMS: { label: string; path: string }[] = [
  { label: "Overview", path: ESSAY_PRIZES_OVERVIEW_PATH },
  ...ESSAY_PRIZE_CATEGORIES.map((category) => ({
    label: category.navLabel,
    path: category.path,
  })),
];

export function getEssayPrizeCategory(slug: string | undefined): EssayPrizeCategory | undefined {
  return ESSAY_PRIZE_CATEGORIES.find((c) => c.slug === slug);
}
